{
  "REPORT": {
    "HEADER": "Percakapan",
    "LOADING_CHART": "Memuat data grafik...",
    "NO_ENOUGH_DATA": "Kami belum menerima cukup data untuk membuat laporan, Silakan coba lagi nanti.",
    "DOWNLOAD_CONVERSATION_REPORTS": "Download conversation reports",
    "DATA_FETCHING_FAILED": "Gagal mengambil data, silakan coba lagi nanti.",
    "SUMMARY_FETCHING_FAILED": "Gagal mengambil ringkasan, silakan coba lagi nanti.",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Percakapan",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Pesan Masuk",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Pesan Keluar",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Waktu Respon Pertama",
        "DESC": "( Rata-Rata )",
        "INFO_TEXT": "Total jumlah percakapan yang digunakan untuk perhitungan:",
        "TOOLTIP_TEXT": "Waktu Respon Pertama adalah {metricValue} (berdasarkan {conversationCount} percakapan)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Waktu Penyelesaian",
        "DESC": "( Rata-Rata )",
        "INFO_TEXT": "Total jumlah percakapan yang digunakan untuk perhitungan:",
        "TOOLTIP_TEXT": "Waktu Penyelesaian adalah {metricValue} (berdasarkan {conversationCount} percakapan)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Jumlah Terselesaikan",
        "DESC": "( Total )"
      },
      "BOT_RESOLUTION_COUNT": {
        "NAME": "Jumlah Terselesaikan",
        "DESC": "( Total )"
      },
      "BOT_HANDOFF_COUNT": {
        "NAME": "Handoff Count",
        "DESC": "( Total )"
      },
      "REPLY_TIME": {
        "NAME": "Customer waiting time",
        "TOOLTIP_TEXT": "Waiting time is {metricValue} (based on {conversationCount} replies)",
        "DESC": ""
      }
    },
    "DATE_RANGE_OPTIONS": {
      "LAST_7_DAYS": "7 hari terakhir",
      "LAST_14_DAYS": "14 hari terakhir",
      "LAST_30_DAYS": "30 hari terakhir",
      "THIS_MONTH": "This month",
      "LAST_MONTH": "Last month",
      "LAST_3_MONTHS": "3 bulan terakhir",
      "LAST_6_MONTHS": "6 bulan terakhir",
      "LAST_YEAR": "Tahun terakhir",
      "CUSTOM_DATE_RANGE": "Rentang tanggal kustom"
    },
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Terapkan",
      "PLACEHOLDER": "Pilih rentang tanggal"
    },
    "GROUP_BY_FILTER_DROPDOWN_LABEL": "Kelompokkan Berdasarkan",
    "DURATION_FILTER_LABEL": "Durasi",
    "GROUPING_OPTIONS": {
      "DAY": "Hari",
      "WEEK": "Minggu",
      "MONTH": "Bulan",
      "YEAR": "Tahun"
    },
    "GROUP_BY_DAY_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Hari"
      }
    ],
    "GROUP_BY_WEEK_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Hari"
      },
      {
        "id": 2,
        "groupBy": "Minggu"
      }
    ],
    "GROUP_BY_MONTH_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Hari"
      },
      {
        "id": 2,
        "groupBy": "Minggu"
      },
      {
        "id": 3,
        "groupBy": "Bulan"
      }
    ],
    "GROUP_BY_YEAR_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Day"
      },
      {
        "id": 2,
        "groupBy": "Week"
      },
      {
        "id": 3,
        "groupBy": "Month"
      }
    ],
    "BUSINESS_HOURS": "Jam Kerja",
    "FILTER_ACTIONS": {
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "Tidak ada hasil ditemukan"
    },
    "DRILLDOWN": {
      "TITLE": "{metric} details",
      "RESULT_COUNT_CONVERSATION": "{count} conversation | {count} conversations",
      "RESULT_COUNT_MESSAGE": "{count} message | {count} messages",
      "EMPTY": "No records found for this bar.",
      "ERROR": "Could not load records. Please try again.",
      "ADMIN_ONLY": "Only administrators can drill down into report records.",
      "LOAD_MORE": "Load more",
      "CLOSE": "Close details",
      "PREVIOUS_BUCKET": "Previous bar",
      "NEXT_BUCKET": "Next bar",
      "UNKNOWN_CONTACT": "Unknown contact",
      "UNKNOWN_INBOX": "Unknown inbox",
      "UNASSIGNED_AGENT": "Belum Ditugaskan",
      "NO_MESSAGE_CONTENT": "No message content",
      "MESSAGE_CREATED_AT": "Message created at {time}",
      "EVENT_OCCURRED_AT": "Event occurred at {time}",
      "INCOMING_MESSAGE": "Incoming message",
      "OUTGOING_MESSAGE": "Outgoing message"
    },
    "PAGINATION": {
      "RESULTS": "Showing {start} to {end} of {total} results",
      "PER_PAGE_TEMPLATE": "{size} / page"
    }
  },
  "AGENT_REPORTS": {
    "HEADER": "Gambaran Agen",
    "DESCRIPTION": "Easily track agent performance with key metrics such as conversations, response times, resolution times, and resolved cases. Click an agent's name to learn more.",
    "LOADING_CHART": "Memuat data grafik...",
    "NO_ENOUGH_DATA": "Kami belum menerima cukup data untuk membuat laporan, Silakan coba lagi nanti.",
    "DOWNLOAD_AGENT_REPORTS": "Unduh laporan agen",
    "FILTER_DROPDOWN_LABEL": "Pilih Agen",
    "FILTERS": {
      "INPUT_PLACEHOLDER": {
        "AGENTS": "Mencari Agen"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Percakapan",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Pesan Masuk",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Pesan Keluar",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Waktu Respon Pertama",
        "DESC": "( Rata-Rata )",
        "INFO_TEXT": "Total jumlah percakapan yang digunakan untuk perhitungan:",
        "TOOLTIP_TEXT": "Waktu Respon Pertama adalah {metricValue} (berdasarkan {conversationCount} percakapan)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Waktu Penyelesaian",
        "DESC": "( Rata-Rata )",
        "INFO_TEXT": "Total jumlah percakapan yang digunakan untuk perhitungan:",
        "TOOLTIP_TEXT": "Waktu Penyelesaian adalah {metricValue} (berdasarkan {conversationCount} percakapan)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Jumlah Terselesaikan",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "7 hari terakhir"
      },
      {
        "id": 1,
        "name": "30 hari terakhir"
      },
      {
        "id": 2,
        "name": "3 bulan terakhir"
      },
      {
        "id": 3,
        "name": "6 bulan terakhir"
      },
      {
        "id": 4,
        "name": "Tahun terakhir"
      },
      {
        "id": 5,
        "name": "Rentang tanggal kustom"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Terapkan",
      "PLACEHOLDER": "Pilih rentang tanggal"
    }
  },
  "LABEL_REPORTS": {
    "HEADER": "Gambaran Label",
    "DESCRIPTION": "Track label performance with key metrics including conversations, response times, resolution times, and resolved cases. Click a label name for detailed insights.",
    "LOADING_CHART": "Memuat data grafik...",
    "NO_ENOUGH_DATA": "Kami belum menerima cukup data untuk membuat laporan, Silakan coba lagi nanti.",
    "DOWNLOAD_LABEL_REPORTS": "Unduh laporan label",
    "FILTER_DROPDOWN_LABEL": "Pilih label",
    "FILTERS": {
      "INPUT_PLACEHOLDER": {
        "LABELS": "Cari label"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Percakapan",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Pesan Masuk",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Pesan Keluar",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Waktu Respon Pertama",
        "DESC": "( Rata-Rata )",
        "INFO_TEXT": "Total jumlah percakapan yang digunakan untuk perhitungan:",
        "TOOLTIP_TEXT": "Waktu Respon Pertama adalah {metricValue} (berdasarkan {conversationCount} percakapan)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Waktu Penyelesaian",
        "DESC": "( Rata-Rata )",
        "INFO_TEXT": "Total jumlah percakapan yang digunakan untuk perhitungan:",
        "TOOLTIP_TEXT": "Waktu Penyelesaian adalah {metricValue} (berdasarkan {conversationCount} percakapan)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Jumlah Terselesaikan",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "7 hari terakhir"
      },
      {
        "id": 1,
        "name": "30 hari terakhir"
      },
      {
        "id": 2,
        "name": "3 bulan terakhir"
      },
      {
        "id": 3,
        "name": "6 bulan terakhir"
      },
      {
        "id": 4,
        "name": "Tahun terakhir"
      },
      {
        "id": 5,
        "name": "Rentang tanggal kustom"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Terapkan",
      "PLACEHOLDER": "Pilih rentang tanggal"
    }
  },
  "INBOX_REPORTS": {
    "HEADER": "Gambaran kontak masuk",
    "DESCRIPTION": "Quickly view your inbox performance with key metrics like conversations, response times, resolution times, and resolved cases—all in one place. Click an inbox name for more details.",
    "LOADING_CHART": "Memuat data grafik...",
    "NO_ENOUGH_DATA": "Kami belum menerima cukup data untuk membuat laporan, Silakan coba lagi nanti.",
    "DOWNLOAD_INBOX_REPORTS": "Unduh laporan kotak masuk",
    "FILTER_DROPDOWN_LABEL": "Pilih kotak masuk",
    "ALL_INBOXES": "All Inboxes",
    "SEARCH_INBOX": "Search Inbox",
    "FILTERS": {
      "INPUT_PLACEHOLDER": {
        "INBOXES": "Search inboxes"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Percakapan",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Pesan Masuk",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Pesan Keluar",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Waktu Respon Pertama",
        "DESC": "( Rata-Rata )",
        "INFO_TEXT": "Total jumlah percakapan yang digunakan untuk perhitungan:",
        "TOOLTIP_TEXT": "Waktu Respon Pertama adalah {metricValue} (berdasarkan {conversationCount} percakapan)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Waktu Penyelesaian",
        "DESC": "( Rata-Rata )",
        "INFO_TEXT": "Total jumlah percakapan yang digunakan untuk perhitungan:",
        "TOOLTIP_TEXT": "Waktu Penyelesaian adalah {metricValue} (berdasarkan {conversationCount} percakapan)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Jumlah Terselesaikan",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "7 hari terakhir"
      },
      {
        "id": 1,
        "name": "30 hari terakhir"
      },
      {
        "id": 2,
        "name": "3 bulan terakhir"
      },
      {
        "id": 3,
        "name": "6 bulan terakhir"
      },
      {
        "id": 4,
        "name": "Tahun terakhir"
      },
      {
        "id": 5,
        "name": "Rentang tanggal kustom"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Terapkan",
      "PLACEHOLDER": "Pilih rentang tanggal"
    }
  },
  "TEAM_REPORTS": {
    "HEADER": "Gambaran Tim",
    "DESCRIPTION": "Get a snapshot of your team's performance with essential metrics, including conversations, response times, resolution times, and resolved cases. Click a team name for more details.",
    "LOADING_CHART": "Memuat data grafik...",
    "NO_ENOUGH_DATA": "Kami belum menerima cukup data untuk membuat laporan, Silakan coba lagi nanti.",
    "DOWNLOAD_TEAM_REPORTS": "Unduh laporan tim",
    "FILTER_DROPDOWN_LABEL": "Pilih Tim",
    "FILTERS": {
      "ADD_FILTER": "Tambah filter",
      "CLEAR_ALL": "Clear all",
      "NO_FILTER": "No filters available",
      "INPUT_PLACEHOLDER": {
        "TEAMS": "Mencari tim"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Percakapan",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Pesan Masuk",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Pesan Keluar",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Waktu Respon Pertama",
        "DESC": "( Rata-Rata )",
        "INFO_TEXT": "Total jumlah percakapan yang digunakan untuk perhitungan:",
        "TOOLTIP_TEXT": "Waktu Respon Pertama adalah {metricValue} (berdasarkan {conversationCount} percakapan)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Waktu Penyelesaian",
        "DESC": "( Rata-Rata )",
        "INFO_TEXT": "Total jumlah percakapan yang digunakan untuk perhitungan:",
        "TOOLTIP_TEXT": "Waktu Penyelesaian adalah {metricValue} (berdasarkan {conversationCount} percakapan)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Jumlah Terselesaikan",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "7 hari terakhir"
      },
      {
        "id": 1,
        "name": "30 hari terakhir"
      },
      {
        "id": 2,
        "name": "3 bulan terakhir"
      },
      {
        "id": 3,
        "name": "6 bulan terakhir"
      },
      {
        "id": 4,
        "name": "Tahun terakhir"
      },
      {
        "id": 5,
        "name": "Rentang tanggal kustom"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Terapkan",
      "PLACEHOLDER": "Pilih rentang tanggal"
    }
  },
  "CSAT_REPORTS": {
    "HEADER": "Laporan CSAT",
    "NO_RECORDS": "No responses yet",
    "NO_RECORDS_DESCRIPTION": "CSAT survey responses will appear here once customers start providing feedback.",
    "DOWNLOAD": "Unduh Laporan CSAT",
    "DOWNLOAD_FAILED": "Gagal mengunduh Laporan CSAT",
    "FILTERS": {
      "ADD_FILTER": "Tambah filter",
      "CLEAR_ALL": "Clear all",
      "NO_FILTER": "No filters available",
      "INPUT_PLACEHOLDER": {
        "AGENTS": "Mencari Agen",
        "INBOXES": "Search inboxes",
        "TEAMS": "Mencari tim",
        "RATINGS": "Search ratings"
      },
      "AGENTS": {
        "LABEL": "Agen"
      },
      "INBOXES": {
        "LABEL": "Kotak masuk"
      },
      "TEAMS": {
        "LABEL": "Tim"
      },
      "RATINGS": {
        "LABEL": "Penilaian"
      }
    },
    "TABLE": {
      "HEADER": {
        "CONTACT_NAME": "Kontak",
        "AGENT_NAME": "Agen",
        "RATING": "Peringkat",
        "FEEDBACK_TEXT": "Komentar umpan balik",
        "CONVERSATION": "Percakapan",
        "CUSTOMER": "Customer",
        "RESPONSE": "Response",
        "HANDLED_BY": "Handled by"
      },
      "UNKNOWN_CUSTOMER": "Unknown customer"
    },
    "NO_AGENT": "No assigned agent",
    "NO_FEEDBACK": "No feedback provided",
    "METRIC": {
      "TOTAL_RESPONSES": {
        "LABEL": "Total respons",
        "TOOLTIP": "Total jumlah respons yang terkumpul"
      },
      "SATISFACTION_SCORE": {
        "LABEL": "Nilai kepuasan",
        "TOOLTIP": "Total jumlah respons positif / Total jumlah respons * 100"
      },
      "RESPONSE_RATE": {
        "LABEL": "Peringkat respons",
        "TOOLTIP": "Total jumlah respons / Total jumlah pesan survey CSAT yang terkirim * 100"
      },
      "RATING_DISTRIBUTION": "Rating distribution"
    },
    "REVIEW_NOTES": {
      "TITLE": "Review notes",
      "PLACEHOLDER": "Add review notes about this rating...",
      "SAVE": "Simpan",
      "CANCEL": "Batalkan",
      "SAVING": "Menyimpan...",
      "SAVED": "Notes saved successfully",
      "SAVE_ERROR": "Failed to save notes",
      "UPDATED_BY": "Updated by {name} {time}",
      "UPDATED_BY_LABEL": "Updated by",
      "PAYWALL": {
        "TITLE": "Upgrade to add review notes",
        "AVAILABLE_ON": "The review notes feature is only available in the Business and Enterprise plans.",
        "UPGRADE_PROMPT": "Add internal context to every CSAT response with review notes. Capture what really happened, spot patterns faster, and make better decisions from your feedback.",
        "UPGRADE_NOW": "Upgrade now",
        "CANCEL_ANYTIME": "You can change or cancel your plan anytime"
      }
    }
  },
  "BOT_REPORTS": {
    "HEADER": "Bot Reports",
    "METRIC": {
      "TOTAL_CONVERSATIONS": {
        "LABEL": "No. of Conversations",
        "TOOLTIP": "Total number of conversations handled by the bot"
      },
      "TOTAL_RESPONSES": {
        "LABEL": "Total Responses",
        "TOOLTIP": "Total number of responses sent by the bot"
      },
      "RESOLUTION_RATE": {
        "LABEL": "Resolution Rate",
        "TOOLTIP": "Total number of conversations resolved by the bot / Total number of conversations handled by the bot * 100"
      },
      "HANDOFF_RATE": {
        "LABEL": "Handoff Rate",
        "TOOLTIP": "Total number of conversations handed off to agents / Total number of conversations handled by the bot * 100"
      }
    }
  },
  "OVERVIEW_REPORTS": {
    "HEADER": "Gambaran",
    "LIVE": "Langsung",
    "ACCOUNT_CONVERSATIONS": {
      "HEADER": "Percakapan Terbuka",
      "LOADING_MESSAGE": "Memuat metrik percakapan...",
      "OPEN": "Terbuka",
      "UNATTENDED": "Tidak Ditangani",
      "UNASSIGNED": "Belum Ditugaskan",
      "PENDING": "Ditunda"
    },
    "CONVERSATION_HEATMAP": {
      "HEADER": "Lalu Lintas Percakapan",
      "NO_CONVERSATIONS": "Tidak ada percakapan",
      "CONVERSATION": "{count} percakapan",
      "CONVERSATIONS": "{count} percakapan",
      "DOWNLOAD_REPORT": "Download report"
    },
    "RESOLUTION_HEATMAP": {
      "HEADER": "Resolutions",
      "NO_CONVERSATIONS": "Tidak ada percakapan",
      "CONVERSATION": "{count} percakapan",
      "CONVERSATIONS": "{count} percakapan",
      "DOWNLOAD_REPORT": "Download report"
    },
    "AGENT_CONVERSATIONS": {
      "HEADER": "Percakapan oleh Agen",
      "LOADING_MESSAGE": "Memuat metrik agen...",
      "NO_AGENTS": "Tidak ada percakapan oleh agen",
      "TABLE_HEADER": {
        "AGENT": "Agen",
        "OPEN": "Terbuka",
        "UNATTENDED": "Tidak Ditangani",
        "STATUS": "Status"
      }
    },
    "TEAM_CONVERSATIONS": {
      "ALL_TEAMS": "All Teams",
      "HEADER": "Conversations by teams",
      "LOADING_MESSAGE": "Loading team metrics...",
      "NO_TEAMS": "There is no data available",
      "TABLE_HEADER": {
        "TEAM": "Tim",
        "OPEN": "Terbuka",
        "UNATTENDED": "Tidak Ditangani",
        "STATUS": "Status"
      }
    },
    "AGENT_STATUS": {
      "HEADER": "Status Agen",
      "ONLINE": "Online",
      "BUSY": "Sibuk",
      "OFFLINE": "Offline"
    }
  },
  "DAYS_OF_WEEK": {
    "SUNDAY": "Minggu",
    "MONDAY": "Senin",
    "TUESDAY": "Selasa",
    "WEDNESDAY": "Rabu",
    "THURSDAY": "Kamis",
    "FRIDAY": "Jumat",
    "SATURDAY": "Sabtu"
  },
  "SLA_REPORTS": {
    "HEADER": "SLA Reports",
    "NO_RECORDS": "SLA applied conversations are not available.",
    "LOADING": "Loading SLA data...",
    "DOWNLOAD_SLA_REPORTS": "Download SLA reports",
    "DOWNLOAD_FAILED": "Failed to download SLA Reports",
    "DROPDOWN": {
      "ADD_FIlTER": "Tambah filter",
      "CLEAR_ALL": "Clear all",
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "Tidak ada hasil ditemukan",
      "NO_FILTER": "No filters available",
      "SEARCH": "Search filter",
      "INPUT_PLACEHOLDER": {
        "SLA": "SLA name",
        "AGENTS": "Nama agen",
        "INBOXES": "Nama kotak masuk",
        "LABELS": "Nama label",
        "TEAMS": "Nama Tim"
      },
      "SLA": "SLA Policy",
      "INBOXES": "Kotak masuk",
      "AGENTS": "Agen",
      "LABELS": "Label",
      "TEAMS": "Tim"
    },
    "WITH": "with",
    "METRICS": {
      "HIT_RATE": {
        "LABEL": "Hit Rate",
        "TOOLTIP": "Percentage of SLAs created were completed successfully"
      },
      "NO_OF_MISSES": {
        "LABEL": "Number of Misses",
        "TOOLTIP": "Total SLA misses in a certain period"
      },
      "NO_OF_CONVERSATIONS": {
        "LABEL": "Number of Conversations",
        "TOOLTIP": "Total number of conversations with SLA"
      }
    },
    "TABLE": {
      "HEADER": {
        "POLICY": "Policy",
        "CONVERSATION": "Percakapan",
        "AGENT": "Agen"
      },
      "VIEW_DETAILS": "View Details"
    }
  },
  "SUMMARY_REPORTS": {
    "INBOX": "Kotak masuk",
    "AGENT": "Agen",
    "TEAM": "Tim",
    "LABEL": "Label",
    "AVG_RESOLUTION_TIME": "Avg. Resolution Time",
    "AVG_FIRST_RESPONSE_TIME": "Avg. First Response Time",
    "AVG_REPLY_TIME": "Avg. Customer Waiting Time",
    "RESOLUTION_COUNT": "Jumlah Terselesaikan",
    "CONVERSATIONS": "Jumlah percakapan"
  }
}
